export default function(dom, opts) {
	let options = {
		baseClass: 'video',
		...opts
	}

	const poster = dom.querySelector(`.${options.baseClass}__poster`);
	let videoUrl;

	if (options.videoPlatform == 'vimeo') {
		videoUrl = `https://player.vimeo.com/video/${options.videoId}?autoplay=1&title=0&byline=0&portrait=0`;
	}
	else if (options.videoPlatform == 'youtube') {
		videoUrl = `https://www.youtube.com/embed/${options.videoId}?autoplay=1`;
	}

	if (videoUrl) {
		poster.addEventListener('click', e => {
			const iframe = document.createElement('iframe');
			iframe.setAttribute('frameborder', 0);
			iframe.allow = "accelerometer; autoplay; fullscreen; clipboard-write; encrypted-media; gyroscope; picture-in-picture";
			iframe.allowFullscreen = true;
			iframe.src = videoUrl;
			poster.parentNode.replaceChild(iframe, poster);
		});
	}
}
